var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu" },
    [
      _vm._l(_vm.navMenus, function(item) {
        return [
          !item.children && !item.hidden
            ? _c(
                "el-menu-item",
                { key: item.path, attrs: { index: item.path } },
                [_vm._v(_vm._s(item.meta.title))]
              )
            : _vm._e(),
          item.children && !item.hidden
            ? _c(
                "el-submenu",
                { key: item.path, attrs: { index: item.path } },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", { class: item.meta.icon }),
                    _c("span", [_vm._v(" " + _vm._s(item.meta.title))])
                  ]),
                  _c("top-Bar", { attrs: { navMenus: item.children } })
                ],
                2
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }